import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_huaban1 from '../views/lanhu_huaban1/index.vue'
import { hasLoginSession } from '@/utils/loginSession'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'lanhu_huaban1',
    component: lanhu_huaban1
  },
  {
    path: '/lanhu_huaban1',
    redirect: '/'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register/survey',
    name: 'registerSurvey',
    component: () => import('../views/FinanceTalentSurvey.vue')
  },
  {
    path: '/user/survey-edit',
    name: 'surveyEdit',
    component: () => import('../views/FinanceTalentSurvey.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackPrefetch: true */ '../views/User.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'user' && !hasLoginSession()) {
    next({ name: 'login', replace: true })
    return
  }
  if (to.name === 'login' && hasLoginSession()) {
    next({ name: 'user', replace: true })
    return
  }
  next()
})

export default router
